export default __webpack_public_path__ + "static/media/limb_small@2x.d586c27c.jpg";